(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/ball-row-lotto.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/ball-row-lotto.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
class RowLotto extends svs.tur.ball.row.Default {
  constructor(_ref) {
    let _ref$balls = _ref.balls,
      balls = _ref$balls === void 0 ? [] : _ref$balls,
      _ref$numbers = _ref.numbers,
      numbers = _ref$numbers === void 0 ? [] : _ref$numbers,
      _ref$extraNumbers = _ref.extraNumbers,
      extraNumbers = _ref$extraNumbers === void 0 ? [] : _ref$extraNumbers,
      description = _ref.description,
      _ref$showWinInfo = _ref.showWinInfo,
      showWinInfo = _ref$showWinInfo === void 0 ? false : _ref$showWinInfo,
      order = _ref.order,
      index = _ref.index,
      size = _ref.size,
      hideWinInfo = _ref.hideWinInfo;
    super({
      balls,
      numbers,
      extraNumbers,
      description,
      index,
      order,
      size,
      showWinInfo,
      hideWinInfo,
      BallClass: svs.tur.ball.Lotto
    });
    this._numbers = numbers;
    this._balls = balls;
  }
  classNames() {
    return ['ball-row-lotto'];
  }
}
svs.tur.ball.row.Lotto = RowLotto;

 })(window);